export const TransformUtil = Symbol.for('TransformUtil');
export const GraphicUtil = Symbol.for('GraphicUtil');
export const LayerService = Symbol.for('LayerService');
export const StaticLayerHandlerContribution = Symbol.for('StaticLayerHandlerContribution');
export const DynamicLayerHandlerContribution = Symbol.for('DynamicLayerHandlerContribution');
export const VirtualLayerHandlerContribution = Symbol.for('VirtualLayerHandlerContribution');
